import { createContext } from 'react';

export interface ChartSizeContext {
  width?: number;
  height?: number;
}

export const ChartSizeContext = createContext<ChartSizeContext>({});
